import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import PieChartComponent from "../../chart/PieChart";
import Chart from "../../chart/bar";
import LoadWraper from "components/LoadWraper";

const ImageStatusCards = React.memo(({ loadingImageValidtion, imageValidtionCount, imageValidtion }) => {
  return (
    <>
      <Row className="mb-4 gx-3 gy-4">
        <Col md={4} className="h-100">
          <Card className="dashbaord-card">
            <Card.Body className="dashboard-card-body d-flex flex-column">
              <div className="d-flex justify-content-center align-items-center">
                <h4>Image</h4>
              </div>
              <div className="flex-grow-1 d-flex justify-content-center align-items-center">
                <LoadWraper isload={loadingImageValidtion}>
                  <PieChartComponent
                    data={imageValidtionCount}
                    total={imageValidtion?.totalImage || 0}
                    lable={"Image"}
                    colors={["#8484ff", "#a4de6d"]}
                  />
                </LoadWraper>

              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={8} className="h-100">
          <Card className="dashbaord-card">
            <Card.Body className="dashboard-card-body d-flex flex-column">
              <div className="d-flex justify-content-center align-items-center">
                <h4>Image Availablity Office wise</h4>
              </div>
              <div className="flex-grow-1 d-flex justify-content-center align-items-center">
                <LoadWraper isload={loadingImageValidtion}>
                  <Chart
                    data={imageValidtion?.cscWiseReport}
                    dataKey={"CSCName"}
                    textAnchor={"middle"}
                  />
                </LoadWraper>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
});

export default ImageStatusCards;